import React from 'react';

interface PieChartProps {
  data: { name: string; value: number; color: string }[];
  currency: string | null;
}

export const PieChart: React.FC<PieChartProps> = ({ data, currency }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  let cumulativePercent = 0;

  const getCoordinatesForPercent = (percent: number) => {
    const x = Math.cos(2 * Math.PI * percent);
    const y = Math.sin(2 * Math.PI * percent);
    return [x, y];
  };

  if (total === 0) return <p className="text-center text-gray-500">Žádná data k zobrazení.</p>;

  return (
    <div className="flex flex-col lg:flex-row items-center justify-center gap-8">
      <div className="flex-shrink-0">
        <svg viewBox="-1 -1 2 2" className="w-56 h-56 transform -rotate-90">
          {data.map((item, index) => {
              const percent = item.value / total;
              const [startX, startY] = getCoordinatesForPercent(cumulativePercent);
              cumulativePercent += percent;
              const [endX, endY] = getCoordinatesForPercent(cumulativePercent);
              const largeArcFlag = percent > 0.5 ? 1 : 0;

              const pathData = [
                `M ${startX} ${startY}`, // Move
                `A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY}`, // Arc
                `L 0 0`, // Line to center
              ].join(' ');

              const formattedValue = item.value.toLocaleString('cs-CZ', {
                  style: 'currency',
                  currency: currency || 'CZK',
              });
              
              return (
                <g key={index}>
                    <title>{`${item.name}: ${formattedValue}`}</title>
                    <path d={pathData} fill={item.color} />
                </g>
              );
          })}
        </svg>
      </div>
      <div className="w-full lg:w-48 space-y-2">
        {data.map(item => (
          <div key={item.name} className="flex justify-between items-center text-sm">
            <div className="flex items-center gap-2">
              <span className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: item.color }}></span>
              <span className="truncate" title={item.name}>{item.name}</span>
            </div>
            <span className="font-semibold whitespace-nowrap">{((item.value / total) * 100).toFixed(1)}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};